"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_components_1 = require("@securityproducts/core-components");
var luxon_1 = require("luxon");
var React = __importStar(require("react"));
var logInOutDateTime_styles_1 = require("./logInOutDateTime.styles");
function LogInOutDateTime(props) {
    var spaceDate, date, time;
    if (props.timestamp) {
        spaceDate = luxon_1.DateTime.fromISO(props.timestamp, { zone: props.timezone, setZone: true });
        date = core_components_1.customLocale(spaceDate, props.language, props.dateOptions);
        time = core_components_1.customLocale(spaceDate, props.language, props.timeOptions);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("span", { id: props.id + "-date-value" }, props.timestamp && date !== "" && date !== undefined ? (date) : (React.createElement("div", { className: logInOutDateTime_styles_1.placeholder }, "\u00A0"))),
        React.createElement("span", { id: props.id + "-time-value", className: logInOutDateTime_styles_1.timeValue }, props.timestamp && time !== "" && time !== undefined ? (time) : (React.createElement("div", { className: logInOutDateTime_styles_1.placeholder }, "\u00A0")))));
}
exports.LogInOutDateTime = LogInOutDateTime;
